@if (!canRender) {
  <div class="text-center" style="margin-top: 15em !important; min-width: 480px; max-width: 480px">
    <mat-spinner diameter="24" style="display: inline-block; position: relative; margin-top: 5em">
    </mat-spinner>
  </div>
}

@if (canRender) {
  <div class="ag-pa-md">
    @if (pageStart) {
      <div class="control-panel" style="min-width: 480px; max-width: 480px">
        <div class="text-start semi-bold pointer ag-mb-sm">
          UX Admin > Settings
          <i
            class="fa fa-times pull-right close-sidenav"
            aria-hidden="true"
            title="Close Side Navigation"
            tabindex="0"
            (agInteract)="closeOverlay()"
          ></i>
        </div>
        <div class="padding-10-25 pointer" tabindex="0" (agInteract)="goLogin()">
          Login<i class="fa fa-angle-right pull-right" aria-hidden="true"></i>
        </div>
        <div class="padding-10-25 pointer" tabindex="0" (agInteract)="goSearch()">
          Search and Results<i class="fa fa-angle-right pull-right" aria-hidden="true"></i>
        </div>
        <div class="padding-10-25 pointer" tabindex="0" (agInteract)="goPages()">
          Pages and Widgets<i class="fa fa-angle-right pull-right" aria-hidden="true"></i>
        </div>
        <div class="padding-10-25 pointer" tabindex="0" (agInteract)="goDesign()">
          Design<i class="fa fa-angle-right pull-right" aria-hidden="true"></i>
        </div>
        <div class="padding-10-25 pointer" tabindex="0" (agInteract)="goStaff()">
          Staff Options<i class="fa fa-angle-right pull-right" aria-hidden="true"></i>
        </div>
      </div>
    } @else {
      <!--================================
      =============  LOGIN  ==============
      =================================-->
      @if (login) {
        <div class="control-panel" style="min-width: 480px; max-width: 480px">
          <ng-container
            *ngTemplateOutlet="
              editSidenavHeader;
              context: { title: 'UX Admin > Settings', action: goStart.bind(this) }
            "
          >
          </ng-container>
          <h3 class="text-center">Login</h3>
          <div class="padding-10-25 pointer" tabindex="0" (agInteract)="goLoginForm()">
            Login Form Options
            <i class="fa fa-angle-right pull-right" aria-hidden="true"></i>
          </div>
          @if (userData.isCustSuperUser) {
            <div class="padding-10-25 pointer" tabindex="0" (agInteract)="goDisplayLibs()">
              Display Libraries for Login
              <i class="fa fa-angle-right pull-right" aria-hidden="true"></i>
            </div>
          }
        </div>
      }
      <!-- One for display libraries -->
      @if (loginRes && userData.isCustSuperUser) {
        <div class="control-panel">
          <ng-container
            *ngTemplateOutlet="
              editSidenavHeader;
              context: {
                title: 'Login',
                action: goLogin.bind(this)
              }
            "
          ></ng-container>
          <h3 class="text-center">Display Libraries for Login</h3>
          <div class="margin-25">
            Check a library to include it in the "Select Your Library" drop-down at Login (Login) or
            in the Search Library Information directory (Info).
          </div>
          <div class="width-100">
            <mat-table [dataSource]="librariesDisplayOptions">
              <!-- Login Column -->
              <ng-container matColumnDef="login">
                <mat-header-cell *matHeaderCellDef>Login</mat-header-cell>
                <mat-cell *matCellDef="let resource">
                  <input
                    type="checkbox"
                    [value]="resource.suppressFromLoginDisplay"
                    [attr.title]="resource.libraryProfileKey"
                    [checked]="!resource.suppressFromLoginDisplay"
                    (change)="
                      onchangeDisplayLibrariesOption($event, resource.libraryProfileKey, 'login')
                    "
                  />
                </mat-cell>
              </ng-container>
              <!-- Info Column -->
              <ng-container matColumnDef="info">
                <mat-header-cell *matHeaderCellDef>Info</mat-header-cell>
                <mat-cell *matCellDef="let resource">
                  <input
                    type="checkbox"
                    [value]="resource.suppressFromILLSearch"
                    [attr.title]="resource.libraryProfileKey"
                    [checked]="!resource.suppressFromILLSearch"
                    (change)="
                      onchangeDisplayLibrariesOption($event, resource.libraryProfileKey, 'info')
                    "
                  />
                </mat-cell>
              </ng-container>
              <!-- Code Column -->
              <ng-container matColumnDef="code">
                <mat-header-cell *matHeaderCellDef>Code</mat-header-cell>
                <mat-cell *matCellDef="let resource">{{ resource.libraryCode }}</mat-cell>
              </ng-container>
              <!-- Library Name Column -->
              <ng-container matColumnDef="libraryName">
                <mat-header-cell *matHeaderCellDef>Library Name</mat-header-cell>
                <mat-cell *matCellDef="let resource">{{ resource.description }}</mat-cell>
              </ng-container>
              <mat-header-row
                *matHeaderRowDef="['login', 'info', 'code', 'libraryName']"
                class="stickyHeaderRow"
              ></mat-header-row>
              <mat-row
                *matRowDef="let row; columns: ['login', 'info', 'code', 'libraryName']"
              ></mat-row>
            </mat-table>
            <div class="width-100 height-50">
              <button
                class="btn btn-primary pull-right ag-ma-md"
                type="button"
                (click)="saveDisplayLibraries()"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      }
      <!-- one for login form options -->
      @if (loginFormOpt) {
        <div class="control-panel">
          <ng-container
            *ngTemplateOutlet="
              editSidenavHeader;
              context: {
                title: 'Login',

                action: goLogin.bind(this)
              }
            "
          ></ng-container>
          @if (loginOptions) {
            <h3 class="text-center">Login Form Options</h3>
          }
          <form #f="ngForm" novalidate (ngSubmit)="saveLoginOptions(f)">
            <div class="container-fluid">
              @if (loginOptions) {
                <div class="row">
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <label for="loginInstructions">Login Instructional Text</label>
                      <mat-form-field appearance="outline" class="width-100">
                        <textarea
                          #loginInstructionalText="ngModel"
                          matInput
                          required
                          maxlength="240"
                          id="loginInstructions"
                          rows="3"
                          name="loginInstructionalText"
                          [(ngModel)]="loginOptions.loginInstructionalText"
                        ></textarea>
                        <mat-hint align="end"
                          >{{ loginOptions.loginInstructionalText?.length || 0 }}/240</mat-hint
                        >
                      </mat-form-field>
                    </div>
                    <div class="form-group">
                      <label for="userNameLabel">Username Prompt Label</label>
                      <mat-form-field appearance="outline" class="width-100">
                        <input
                          #userNameLabel="ngModel"
                          matInput
                          required
                          maxlength="50"
                          id="userNameLabel"
                          name="userNameLabel"
                          placeholder="Enter Username Label"
                          aria-label="Username Prompt Label"
                          [(ngModel)]="loginOptions.userNameLabel"
                        />
                        <mat-hint align="end"
                          >{{ loginOptions.userNameLabel?.length || 0 }}/50</mat-hint
                        >
                      </mat-form-field>
                    </div>
                    <div class="form-group">
                      <label for="passwordLabel">Password Prompt Label</label>
                      <mat-form-field appearance="outline" class="width-100">
                        <input
                          #passwordLabel="ngModel"
                          matInput
                          required
                          id="passwordLabel"
                          name="passwordLabel"
                          maxlength="50"
                          [(ngModel)]="loginOptions.passwordLabel"
                        />
                        <mat-hint align="end"
                          >{{ loginOptions.passwordLabel?.length || 0 }}/50</mat-hint
                        >
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <mat-checkbox
                        #showForgotPasswordLink="ngModel"
                        name="showForgotPasswordLink"
                        [(ngModel)]="loginOptions.showForgotPasswordLink"
                      >
                        Display Forgot Password Link
                      </mat-checkbox>
                    </div>
                    <div class="form-group">
                      <mat-checkbox
                        #showLibraryLookupBox="ngModel"
                        name="showLibraryLookupBox"
                        [(ngModel)]="loginOptions.showLibraryLookupBox"
                      >
                        Display Library Lookup Box
                      </mat-checkbox>
                    </div>
                    <div class="form-group">
                      <mat-checkbox
                        #requireLoginBeforSearch="ngModel"
                        name="requireLoginBeforSearch"
                        [(ngModel)]="loginOptions.requireLoginBeforSearch"
                      >
                        You must login to the system before searching the catalog
                      </mat-checkbox>
                    </div>
                    <div class="form-group">
                      <mat-checkbox
                        #redirectToAdvancedSearch="ngModel"
                        name="redirectToAdvancedSearch"
                        [(ngModel)]="loginOptions.redirectToAdvancedSearch"
                      >
                        Direct to Advanced Search after Login
                      </mat-checkbox>
                    </div>
                    <div class="form-group">
                      <mat-checkbox
                        #showPasswordPrompt="ngModel"
                        name="showPasswordPrompt"
                        [(ngModel)]="loginOptions.showPasswordPrompt"
                      >
                        Show Password Prompt
                      </mat-checkbox>
                    </div>
                    <div class="form-group">
                      <label for="emailText">Forgot Password Email Text</label>
                      <mat-form-field appearance="outline" class="width-100">
                        <textarea
                          #loginInstructionalText="ngModel"
                          matInput
                          maxlength="240"
                          id="emailText"
                          rows="3"
                          name="emailText"
                          [(ngModel)]="loginOptions.emailText"
                        ></textarea>
                        <mat-hint align="end"
                          >{{ loginOptions.emailText?.length || 0 }}/240</mat-hint
                        >
                      </mat-form-field>
                    </div>
                    <div class="form-group">
                      <button
                        aria-label="Save"
                        class="btn btn-primary pull-right"
                        type="submit"
                        [disabled]="!f.form.valid"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              }
            </div>
          </form>
        </div>
      }
      <!--
            ===================================
            ============= SEARCH ==============
            ===================================
            -->
      @if (search) {
        <div class="control-panel" style="min-width: 480px; max-width: 480px">
          <ng-container
            *ngTemplateOutlet="
              editSidenavHeader;
              context: {
                title: 'UX Admin > Settings',
                action: goStart.bind(this)
              }
            "
          ></ng-container>
          <div>
            <h3 class="text-center">Search and Results</h3>
            <div class="padding-10-25 pointer" tabindex="0" (agInteract)="goSimple()">
              Quick Search
              <i class="fa fa-angle-right pull-right" aria-hidden="true"></i>
            </div>
            <div class="padding-10-25 pointer" tabindex="0" (agInteract)="goResults()">
              Search Results
              <i class="fa fa-angle-right pull-right" aria-hidden="true"></i>
            </div>
            <div class="padding-10-25 pointer" tabindex="0" (agInteract)="goZeroResults()">
              Zero Results
              <i class="fa fa-angle-right pull-right" aria-hidden="true"></i>
            </div>
            <div class="padding-10-25 pointer" tabindex="0" (agInteract)="goRDP()">
              Brief Record Display Profile
              <i class="fa fa-angle-right pull-right" aria-hidden="true"></i>
            </div>
            <div class="padding-10-25 pointer" tabindex="0" (agInteract)="goFacets()">
              Facets Management
              <i class="fa fa-angle-right pull-right" aria-hidden="true"></i>
            </div>
            <div class="padding-10-25 pointer" tabindex="0" (agInteract)="goDetail()">
              Full Record
              <i class="fa fa-angle-right pull-right" aria-hidden="true"></i>
            </div>
            <div class="padding-10-25 pointer" tabindex="0" (agInteract)="goAdvanced()">
              Advanced Search
              <i class="fa fa-angle-right pull-right" aria-hidden="true"></i>
            </div>
            <div class="padding-10-25 pointer" tabindex="0" (agInteract)="goBrowse()">
              Web Links
              <i class="fa fa-angle-right pull-right" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      }
      <!--
          //////////////////////  QUICK SEARCH ///////////////////////////////
          -->
      @if (simple) {
        <div class="control-panel width-400">
          <ng-container
            *ngTemplateOutlet="
              editSidenavHeader;
              context: {
                title: 'Search and Results',
                action: goSearchOptions.bind(this)
              }
            "
          ></ng-container>
          <form #simple="ngForm" (ngSubmit)="saveSimpleSearchOptions(simple)">
            @if (searchOptions) {
              <div>
                <h3 class="text-center">Quick Search</h3>
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-12 col-md-6 col-lg-4">
                      <div class="form-group">
                        <label for="displayIndexSelection" class="color-header-color bold">
                          Display Index Selection
                        </label>
                        <mat-checkbox
                          class="ag-px-md"
                          id="displayIndexSelection"
                          name="indexSelectionStaff"
                          [(ngModel)]="searchOptions.simple.displayIndexSelectionForStaff"
                        >
                          Staff
                        </mat-checkbox>
                        <mat-checkbox
                          class="ag-px-md"
                          name="indexSelectionPatronGuest"
                          [(ngModel)]="searchOptions.simple.displayIndexSelectionForPatronsGuests"
                        >
                          Patron
                        </mat-checkbox>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4">
                      <div class="form-group">
                        <label for="displayResourceSelection" class="color-header-color bold"
                          >Display Resource Selection</label
                        >
                        <mat-checkbox
                          class="ag-px-md"
                          id="displayResourceSelection"
                          name="resourcesSelectionStaff"
                          [(ngModel)]="searchOptions.simple.displayResourceSelectionForStaff"
                          >Staff
                        </mat-checkbox>
                        <mat-checkbox
                          class="ag-px-md"
                          name="resourcesSelectionPatronGuest"
                          [(ngModel)]="
                            searchOptions.simple.displayResourceSelectionForPatronsGuests
                          "
                          >Patron
                        </mat-checkbox>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4">
                      <div class="form-group">
                        <label for="enableTypeAhead" class="color-header-color bold"
                          >Enable Type Ahead</label
                        >
                        <mat-checkbox
                          class="ag-px-md"
                          id="enableTypeAhead"
                          name="typeAheadStaff"
                          [(ngModel)]="searchOptions.simple.enableTypeAheadForStaff"
                          >Staff
                        </mat-checkbox>
                        <mat-checkbox
                          class="ag-px-md"
                          name="typeAheadPatronGuest"
                          [(ngModel)]="searchOptions.simple.enableTypeAheadForPatronsGuests"
                          >Patron
                        </mat-checkbox>
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="form-group">
                        <label for="selectForm">Search Box Default Index</label>
                        <mat-form-field appearance="outline" class="width-100">
                          <mat-select
                            id="selectForm"
                            name="searchBoxDefaultValue"
                            [compareWith]="compareWithValue"
                            [(ngModel)]="searchOptions.simple.searchBoxDefaultIndex"
                          >
                            @for (item of searchOptions.simple.searchIndexes; track item) {
                              <mat-option [value]="item.value">
                                {{ item.name }}
                              </mat-option>
                            }
                          </mat-select>
                          <mat-hint align="end"
                            >What is displayed first when visiting site.</mat-hint
                          >
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-12 text-end">
                      <button aria-label="Save" class="btn btn-primary pull-right" type="submit">
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            }
          </form>
        </div>
      }
      <!--New Brief Record Display Profile -->
      @if (briefRecordDisplayProfile) {
        <div class="control-panel">
          <ng-container
            *ngTemplateOutlet="
              editSidenavHeader;
              context: {
                title: 'Search and Results',
                action: goSearchOptions.bind(this)
              }
            "
          ></ng-container>
          <h3 class="text-center">Brief Record Display Profile</h3>
          <div class="text-center ag-mb-sm" style="min-height: 20px">
            @if (briefRecordSaving) {
              <mat-spinner diameter="16" style="margin: 0 auto"></mat-spinner>
            }
            @if (briefRecordSaved) {
              <small>Saved</small>
            }
          </div>
          <div class="container-fluid">
            <div class="row">
              <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px" class="ag-mb-sm">
                <button mat-stroked-button type="button" (click)="addBriefRecordDisplayField()">
                  Add Field
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-12">
                <form #newRDPForm="ngForm">
                  @if (briefRecordDisplayData) {
                    <div
                      class="drag-list drag-list-editable"
                      cdkDropList
                      (cdkDropListDropped)="
                        dropBriefRecordDisplayField($event, briefRecordDisplayData)
                      "
                    >
                      @for (rdp of briefRecordDisplayData; track rdp; let i = $index) {
                        <div
                          cdkDrag
                          tabindex="0"
                          class="drag-list-item ag-pa-sm"
                          [cdkContextMenuTriggerFor]="rdpMenu.template"
                          (cdkContextMenuOpened)="rdpMenu.setIndex(i)"
                        >
                          <div *cdkDragPlaceholder class="drag-placeholder"></div>
                          <div
                            fxLayout="row"
                            fxFlex
                            fxLayoutAlign="start center"
                            fxLayoutGap="10px"
                          >
                            <div>
                              <mat-icon>drag_handle</mat-icon>
                            </div>
                            <div
                              fxFlex
                              class="truncate-ellipsis pointer"
                              tabindex="0"
                              (agInteract)="editBriefRecordDisplayProfile(rdp, i)"
                            >
                              <div><strong>Label:</strong> {{ rdp.label }}</div>
                              <div>
                                <strong>Tag:</strong> {{ rdp.tagId }}, <strong>Subfields:</strong>
                                {{ rdp.subfields }}
                              </div>
                            </div>
                            <button
                              mat-icon-button
                              type="button"
                              (click)="editBriefRecordDisplayProfile(rdp, i)"
                            >
                              <mat-icon>edit</mat-icon>
                            </button>
                            <button
                              mat-icon-button
                              type="button"
                              (click)="deleteBriefRecordDisplayProfile(i)"
                            >
                              <mat-icon>delete</mat-icon>
                            </button>
                          </div>
                        </div>
                      }
                      <ag-reorder-context-menu
                        #rdpMenu
                        [total]="$safeNavigationMigration(briefRecordDisplayData?.length)"
                        (move)="moveBriefRecordDisplayField($event.from, $event.to)"
                        (remove)="deleteBriefRecordDisplayProfile($event)"
                      ></ag-reorder-context-menu>
                    </div>
                  }
                </form>
              </div>
            </div>
          </div>
        </div>
      }
      <!-- FORM for add and edit of new record display fields for new RDP -->
      @if (!briefRecordDisplayProfile && showBriefRecordDisplayProfileForm) {
        <div class="control-panel">
          <ng-container
            *ngTemplateOutlet="
              editSidenavHeader;
              context: {
                title: 'Brief Record Display Profile',
                action: goRDP.bind(this)
              }
            "
          ></ng-container>
          <div class="container-fluid">
            <div class="row">
              <div class="col-12 col-lg-12 col-md-12">
                <form
                  (ngSubmit)="validNewBriefRecordDisplayForm(newRdpForm)"
                  [formGroup]="newRdpForm"
                >
                  <div class="form-group">
                    <label for="tagId">Tag Id:</label>
                    <input type="text" id="tagId" class="form-control" formControlName="tagId" />
                  </div>
                  <div class="form-group">
                    <label for="subfields">Subfields:</label>
                    <input
                      type="text"
                      id="subfields"
                      class="form-control"
                      formControlName="subfields"
                    />
                  </div>
                  <div class="form-group">
                    <label for="label">Label:</label>
                    <input type="text" id="label" class="form-control" formControlName="label" />
                  </div>
                  <button
                    aria-label="Submit"
                    type="submit"
                    class="btn btn-primary"
                    [disabled]="!newRdpForm?.valid"
                  >
                    Save
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      }
      <!-- Zero RESULTS -->
      @if (zeroResults) {
        <div class="control-panel">
          <ng-container
            *ngTemplateOutlet="
              editSidenavHeader;
              context: {
                title: 'Search and Results',
                action: goSearchOptions.bind(this)
              }
            "
          ></ng-container>
          <edit-c-text [zeroResults]="zeroResults"></edit-c-text>
        </div>
      }
      <!-- Search RESULTS -->
      @if (results) {
        <div class="control-panel">
          <ng-container
            *ngTemplateOutlet="
              editSidenavHeader;
              context: {
                title: 'Search and Results',
                action: goSearchOptions.bind(this)
              }
            "
          ></ng-container>
          <div>
            @if (resultOptions) {
              <h3 class="text-center">Search Results</h3>
            }
            <div class="container-fluid">
              <div class="row">
                <div class="col-12 col-md-6 col-lg-4">
                  <div class="form-group">
                    <label for="defaultResultsView" class="color-header-color bold"
                      >Default Results View</label
                    >
                    <mat-radio-group
                      id="defaultResultsView"
                      name="resultViewPatronGuest"
                      [(ngModel)]="resultViewPatronGuestDefault"
                    >
                      @for (item of resultOptions?.resultView.patronGuest; track item) {
                        <mat-radio-button class="block" [value]="item.value" [name]="item.name"
                          >Patron - {{ item.name }}
                        </mat-radio-button>
                      }
                    </mat-radio-group>
                    <hr class="margin-5" />
                    <mat-radio-group name="resultViewStaff" [(ngModel)]="resultViewStaffDefault">
                      @for (item of resultOptions?.resultView.staff; track item) {
                        <mat-radio-button class="block" [value]="item.value" [name]="item.name"
                          >Staff - {{ item.name }}
                        </mat-radio-button>
                      }
                    </mat-radio-group>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                  <div class="form-group">
                    <label for="displayPrintOptions" class="color-header-color bold"
                      >Display PRINT Options</label
                    >
                    <mat-radio-group
                      id="displayPrintOptions"
                      name="printOptionPatronGuest"
                      [(ngModel)]="printOptionPatronGuestDefault"
                    >
                      @for (item of resultOptions?.printOption.patronGuest; track item) {
                        <mat-radio-button class="block" [value]="item.value" [name]="item.name"
                          >Patron - {{ item.name }}
                        </mat-radio-button>
                      }
                    </mat-radio-group>
                    <hr class="margin-5" />
                    <mat-radio-group name="printOptionStaff" [(ngModel)]="printOptionStaffDefault">
                      @for (item of resultOptions?.printOption.staff; track item) {
                        <mat-radio-button class="block" [value]="item.value" [name]="item.name"
                          >Staff - {{ item.name }}
                        </mat-radio-button>
                      }
                    </mat-radio-group>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                  <div class="form-group">
                    <label for="displayJacketArt" class="color-header-color bold"
                      >Display Jacket Art on List View</label
                    >
                    <mat-radio-group
                      id="displayJacketArt"
                      name="jacketArtOnListViewPatronGuest"
                      [(ngModel)]="jacketArtListPatronGuestDefault"
                    >
                      @for (item of resultOptions?.jacketArtOnListView.patronGuest; track item) {
                        <mat-radio-button class="block" [value]="item.value" [name]="item.name"
                          >Patron - {{ item.name }}
                        </mat-radio-button>
                      }
                    </mat-radio-group>
                    <hr class="margin-5" />
                    <mat-radio-group
                      name="jacketArtOnListViewStaff"
                      [(ngModel)]="jacketArtListStaffDefault"
                    >
                      @for (item of resultOptions?.jacketArtOnListView.staff; track item) {
                        <mat-radio-button class="block" [value]="item.value" [name]="item.name"
                          >Staff - {{ item.name }}
                        </mat-radio-button>
                      }
                    </mat-radio-group>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                  <div class="form-group">
                    <label for="displaySeeMoreFrom" class="color-header-color bold">
                      Display 'See More From' View
                    </label>
                    <mat-radio-group
                      id="displaySeeMoreFrom"
                      name="seeMoreFromPatronGuest"
                      [(ngModel)]="seeMoreFromPatronGuest"
                    >
                      @for (item of resultOptions?.seeMoreFrom.patronGuest; track item) {
                        <mat-radio-button class="block" [value]="item.value" [name]="item.name"
                          >Patron - {{ item.name }}
                        </mat-radio-button>
                      }
                    </mat-radio-group>
                    <hr class="margin-5" />
                    <mat-radio-group name="seeMoreFromStaff" [(ngModel)]="seeMoreFromStaff">
                      @for (item of resultOptions?.seeMoreFrom.staff; track item) {
                        <mat-radio-button class="block" [value]="item.value" [name]="item.name"
                          >Staff - {{ item.name }}
                        </mat-radio-button>
                      }
                    </mat-radio-group>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                  <div class="form-group">
                    <label for="displayShowingResultsFor" class="color-header-color bold">
                      Display 'Showing Results For:'
                    </label>
                    <mat-radio-group
                      id="displayShowingResultsFor"
                      name="showingResultsForPatronGuest"
                      [(ngModel)]="showingResultsForPatronGuest"
                    >
                      @for (item of resultOptions?.showingResultsFor.patronGuest; track item) {
                        <mat-radio-button class="block" [value]="item.value" [name]="item.name"
                          >Patron - {{ item.name }}
                        </mat-radio-button>
                      }
                    </mat-radio-group>
                    <hr class="margin-5" />
                    <mat-radio-group
                      name="showingResultsForStaff"
                      [(ngModel)]="showingResultsForStaff"
                    >
                      @for (item of resultOptions?.showingResultsFor.staff; track item) {
                        <mat-radio-button class="block" [value]="item.value" [name]="item.name"
                          >Staff - {{ item.name }}
                        </mat-radio-button>
                      }
                    </mat-radio-group>
                  </div>
                </div>
                @if (isShareIt) {
                  <div class="col-12 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label
                        for="displayTitlesWithoutRequestableHoldings"
                        class="color-header-color bold"
                      >
                        Display Titles Without Requestable Holdings
                      </label>
                      <mat-radio-group
                        id="displayTitlesWithoutRequestableHoldings"
                        name="includeTitlesWithoutRequestableHoldingsPatronGuest"
                        [(ngModel)]="includeTitlesWithoutRequestableHoldingsPatronGuest"
                      >
                        @for (
                          item of resultOptions?.includeTitlesWithoutRequestableHoldings
                            ?.patronGuest;
                          track item.value
                        ) {
                          <mat-radio-button class="block" [value]="item.value" [name]="item.name"
                            >Patron - {{ item.name }}
                          </mat-radio-button>
                        }
                      </mat-radio-group>
                      <hr class="margin-5" />
                      <mat-radio-group
                        name="includeTitlesWithoutRequestableHoldingsStaff"
                        [(ngModel)]="includeTitlesWithoutRequestableHoldingsStaff"
                      >
                        @for (
                          item of resultOptions?.includeTitlesWithoutRequestableHoldings?.staff;
                          track item.value
                        ) {
                          <mat-radio-button class="block" [value]="item.value" [name]="item.name"
                            >Staff - {{ item.name }}
                          </mat-radio-button>
                        }
                      </mat-radio-group>
                    </div>
                  </div>
                }
                <div class="col-12 col-md-6 col-lg-4">
                  <!-- enable search highlight -->
                  <div class="form-group">
                    <label for="enableSearchHighlight" class="color-header-color bold"
                      >Enable Search Highlight</label
                    >
                    <mat-radio-group
                      id="enableSearchHighlight"
                      name="enableSeachHighlightPatronsGuests"
                      [(ngModel)]="enableSeachHighlightPatronsGuests"
                    >
                      @for (item of resultOptions?.enableSearchHighlight.patronGuest; track item) {
                        <mat-radio-button class="block" [value]="item.value" [name]="item.name"
                          >Patron - {{ item.name }}
                        </mat-radio-button>
                      }
                    </mat-radio-group>
                    <hr class="margin-5" />
                    <mat-radio-group
                      name="enableSeachHighlightStaff"
                      [(ngModel)]="enableSeachHighlightStaff"
                    >
                      @for (item of resultOptions?.enableSearchHighlight.staff; track item) {
                        <mat-radio-button class="block" [value]="item.value" [name]="item.name"
                          >Staff - {{ item.name }}
                        </mat-radio-button>
                      }
                    </mat-radio-group>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                  <!--- search results type -->
                  <div class="form-group">
                    <label for="showSearchGrouping" class="color-header-color bold"
                      >Show Search Grouping Options</label
                    >
                    <mat-radio-group
                      id="showSearchGrouping"
                      name="showResultTypesPatronsGuests"
                      [(ngModel)]="showResultTypesPatronsGuests"
                    >
                      @for (item of resultOptions?.showResultTypes.patronGuest; track item) {
                        <mat-radio-button class="block" [value]="item.value" [name]="item.name"
                          >Patron - {{ item.name }}
                        </mat-radio-button>
                      }
                    </mat-radio-group>
                    <hr class="margin-5" />
                    <mat-radio-group name="showResultTypesStaff" [(ngModel)]="showResultTypesStaff">
                      @for (item of resultOptions?.showResultTypes.staff; track item) {
                        <mat-radio-button class="block" [value]="item.value" [name]="item.name"
                          >Staff - {{ item.name }}
                        </mat-radio-button>
                      }
                    </mat-radio-group>
                  </div>
                </div>
                @if (!isShareIt) {
                  <div class="col-12 col-md-6 col-lg-4">
                    <!--- browse indexes -->
                    <div class="form-group">
                      <label for="browseIndexes" class="color-header-color bold"
                        >Browse Indexes</label
                      >
                      <mat-radio-group
                        id="browseIndexes"
                        name="showBrowseIndexesPatronsGuests"
                        [(ngModel)]="showBrowseIndexesPatronGuests"
                      >
                        @for (
                          item of resultOptions?.showBrowseIndexesDisplay.patronGuest;
                          track item
                        ) {
                          <mat-radio-button class="block" [value]="item.value" [name]="item.name"
                            >Patron - {{ item.name }}
                          </mat-radio-button>
                        }
                      </mat-radio-group>
                      <hr class="margin-5" />
                      <mat-radio-group
                        name="showBrowseIndexesStaff"
                        [(ngModel)]="showBrowseIndexesStaff"
                      >
                        @for (item of resultOptions?.showBrowseIndexesDisplay.staff; track item) {
                          <mat-radio-button class="block" [value]="item.value" [name]="item.name"
                            >Staff - {{ item.name }}
                          </mat-radio-button>
                        }
                      </mat-radio-group>
                    </div>
                  </div>
                }
                <div class="col-12 col-md-6 col-lg-4">
                  <div class="form-group">
                    <label for="facetSequence" class="color-header-color bold"
                      >Facet Sequence</label
                    >
                    <mat-radio-group
                      id="facetSequence"
                      name="formatSequenceGeneral"
                      [(ngModel)]="formatSequence"
                    >
                      @for (item of resultOptions?.formatSequence; track item) {
                        <mat-radio-button class="block" [value]="item.value" [name]="item.name"
                          >{{ item.name }}
                        </mat-radio-button>
                      }
                    </mat-radio-group>
                  </div>
                </div>
                <!-- dont remove the code : - 60161 - UG2020-3 OPAC: Suppress Z-target eresources in search results -->
                <!--- eformats display or not  -->
                @if (isShareIt) {
                  <div class="col-12 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="displayEFormats" class="color-header-color bold"
                        >Display eFormats</label
                      >
                      <mat-radio-group
                        id="displayEFormats"
                        name="showEformatsPatronGuests"
                        [(ngModel)]="showEformatsPatronGuests"
                      >
                        @for (item of resultOptions?.eformatOption.patronGuest; track item) {
                          <mat-radio-button class="block" [value]="item.value" [name]="item.name"
                            >Patron - {{ item.name }}
                          </mat-radio-button>
                        }
                      </mat-radio-group>
                      <hr class="margin-5" />
                      <mat-radio-group name="showEformatsStaff" [(ngModel)]="showEformatsStaff">
                        @for (item of resultOptions?.eformatOption.staff; track item) {
                          <mat-radio-button class="block" [value]="item.value" [name]="item.name"
                            >Staff - {{ item.name }}
                          </mat-radio-button>
                        }
                      </mat-radio-group>
                    </div>
                  </div>
                }
              </div>
              <div class="row">
                <div class="col-12 col-md-6">
                  <div class="form-group">
                    <label for="selectForm">Default Results Grouping for Patron</label>
                    <mat-form-field appearance="outline" class="width-100">
                      <mat-select
                        id="selectForm"
                        aria-describedby="selectFormHelp"
                        [(ngModel)]="resultsGroupingPatronGuest"
                      >
                        @for (item of resultOptions?.resultsGrouping.patronGuest; track item) {
                          <mat-option [value]="item.value">
                            {{ item.name }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="form-group">
                    <label for="selectForm">Default Results Grouping for Staff</label>
                    <mat-form-field appearance="outline" class="width-100">
                      <mat-select
                        id="selectForm"
                        aria-describedby="selectFormHelp"
                        [(ngModel)]="resultsGroupingStaff"
                      >
                        @for (item of resultOptions?.resultsGrouping.staff; track item) {
                          <mat-option [value]="item.value">
                            {{ item.name }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="form-group">
                    <label for="selectForm">Default Results Sort for Patron</label>
                    <mat-form-field appearance="outline" class="width-100">
                      <mat-select
                        id="selectForm"
                        aria-describedby="selectFormHelp"
                        [(ngModel)]="resultsSortPatronGuest"
                      >
                        @for (item of resultOptions?.resultsSort.patronGuest; track item) {
                          @if (
                            resultsGroupingPatronGuest !== '1' ||
                            (resultsGroupingPatronGuest === '1' && item.value < '5')
                          ) {
                            <mat-option [value]="item.value">
                              {{ item.name }}
                            </mat-option>
                          }
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="form-group">
                    <label for="selectForm">Default Results Sort for Staff</label>
                    <mat-form-field appearance="outline" class="width-100">
                      <mat-select
                        id="selectForm"
                        aria-describedby="selectFormHelp"
                        [(ngModel)]="resultsSortStaff"
                      >
                        @for (item of resultOptions?.resultsSort.staff; track item) {
                          @if (
                            resultsGroupingStaff !== '1' ||
                            (resultsGroupingStaff === '1' && item.value < '5')
                          ) {
                            <mat-option [value]="item.value">
                              {{ item.name }}
                            </mat-option>
                          }
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              @if (isShareIt) {
                <div class="row">
                  <div class="col-12">
                    <!--- Show Resource Details and Availability on List View & Brief Browse -->
                    <div class="form-group">
                      <!-- Does this need to be a label? -->
                      <div>
                        <label
                          for="showResourceDetails"
                          class="color-header-color bold header-no-margin-bottom"
                          >Show Resource Details and Availability on List and Brief Views</label
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <span class="sub-group-header">Patrons/Guests:</span>
                      <mat-radio-group
                        name="showResourceDetailsDisplayPatronGuests"
                        [(ngModel)]="showResourceDetailsDisplayPatronGuests"
                      >
                        @for (
                          item of resultOptions?.showResourceDetailsDisplay?.patronGuest;
                          track item
                        ) {
                          <mat-radio-button class="block" [value]="item.value" [name]="item.name"
                            >{{ item.name }}
                          </mat-radio-button>
                        }
                      </mat-radio-group>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <span class="sub-group-header">Staff:</span>
                      <mat-radio-group
                        name="showResourceDetailsDisplayStaff"
                        [(ngModel)]="showResourceDetailsDisplayStaff"
                      >
                        @for (
                          item of resultOptions?.showResourceDetailsDisplay?.staff;
                          track item
                        ) {
                          <mat-radio-button class="block" [value]="item.value" [name]="item.name"
                            >{{ item.name }}
                          </mat-radio-button>
                        }
                      </mat-radio-group>
                    </div>
                  </div>
                </div>
              }
            </div>
            <div class="width-100 text-end">
              <button
                type="button"
                aria-label="Save"
                class="btn btn-primary pull-right"
                (click)="saveResultOptions()"
              >
                Save
              </button>
            </div>
            <br /><br />
          </div>
        </div>
      }
      <!-- ADVANCED SEARCH -->
      @if (advanced) {
        <div class="control-panel">
          <ng-container
            *ngTemplateOutlet="
              editSidenavHeader;
              context: {
                title: 'Search and Results',
                action: goSearchOptions.bind(this)
              }
            "
          ></ng-container>
          <div class="padding-10-25 pointer" tabindex="0" (agInteract)="goCurrentAS()">
            Advanced Search Settings
            <i class="fa fa-angle-right pull-right" aria-hidden="true"></i>
          </div>
          <div class="padding-10-25 pointer" tabindex="0" (agInteract)="goNewAS()">
            Advanced Search Qualifiers
            <i class="fa fa-angle-right pull-right" aria-hidden="true"></i>
          </div>
        </div>
      }
      @if (currentAS) {
        <div class="control-panel">
          <ng-container
            *ngTemplateOutlet="
              editSidenavHeader;
              context: {
                title: 'Advanced Search',
                action: goAdvanced.bind(this)
              }
            "
          ></ng-container>
          @if (advSearchOptions) {
            <form #f="ngForm" (ngSubmit)="saveAdvancedSearchOptions(f)">
              <h3 class="text-center" style="margin-right: 25%">Advanced Search Settings</h3>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-12 mw-80">
                    <div class="form-group">
                      <label for="npageTitle">Filter Tab Label</label>
                      <mat-form-field appearance="outline" class="width-100 no-wrapper">
                        <input
                          matInput
                          type="email"
                          id="npageTitle"
                          maxlength="20"
                          placeholder="Filter Tab Label"
                          aria-label="Filter Tab Label"
                          name="filterTabLabel"
                          [(ngModel)]="advSearchOptions.filterTabLabel"
                        />
                      </mat-form-field>
                      <mat-hint align="end">
                        {{ advSearchOptions.filterTabLabel?.length || 0 }}/20
                      </mat-hint>
                    </div>
                  </div>
                  <div class="col-12 mw-80">
                    <div class="form-group">
                      <label for="npageTitle">Resources Tab Label</label>
                      <mat-form-field appearance="outline" class="width-100 no-wrapper">
                        <input
                          matInput
                          type="email"
                          id="npageTitle"
                          maxlength="20"
                          placeholder="Resources Tab Label"
                          aria-label="Resources Tab Label"
                          name="resourceTabLabel"
                          [(ngModel)]="advSearchOptions.resourceTabLabel"
                        />
                      </mat-form-field>
                      <mat-hint align="end">
                        {{ advSearchOptions.resourceTabLabel?.length || 0 }}/20
                      </mat-hint>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mw-80">
                    <div>
                      <label for="searchBox">Search Box One Default Index</label>
                      <br />
                      <mat-form-field appearance="outline" class="width-100">
                        <mat-select
                          id="searchBox"
                          aria-describedby="Search Box Display Options"
                          name="searchBoxOneDefaultIndex"
                          [compareWith]="compareWithValue"
                          [(ngModel)]="advSearchOptions.searchBoxOneDefaultIndex"
                        >
                          @for (item of advSearchOptions.searchIndexes; track item) {
                            <mat-option [value]="item.value">
                              {{ item.name }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-12 mw-80">
                    <div>
                      <label for="searchBox">Search Box Two Default Index</label>
                      <mat-form-field appearance="outline" class="width-100">
                        <mat-select
                          id="searchBox"
                          aria-describedby="Search Box Display Options"
                          name="searchBoxTwoDefaultIndex"
                          [compareWith]="compareWithValue"
                          [(ngModel)]="advSearchOptions.searchBoxTwoDefaultIndex"
                        >
                          @for (item of advSearchOptions.searchIndexes; track item) {
                            <mat-option [value]="item.value">
                              {{ item.name }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-12 mw-80">
                    <div>
                      <label for="searchBox">Search Box Three Default Index</label>
                      <mat-form-field appearance="outline" class="width-100">
                        <mat-select
                          id="searchBox"
                          aria-describedby="Search Box Display Options"
                          name="searchBoxThreeeDefaultIndex"
                          [compareWith]="compareWithValue"
                          [(ngModel)]="advSearchOptions.searchBoxThreeeDefaultIndex"
                        >
                          @for (item of advSearchOptions.searchIndexes; track item) {
                            <mat-option [value]="item.value">
                              {{ item.name }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-12 mw-80">
                    <div class="form-group">
                      <label for="enableTypeAhead">Enable Type Ahead</label>
                      <div class="ag-px-md" id="enableTypeAhead">
                        <mat-checkbox
                          class="ag-mx-md"
                          name="enableTypeAheadForStaff"
                          [(ngModel)]="advSearchOptions.enableTypeAheadForStaff"
                          >Staff
                        </mat-checkbox>
                      </div>
                      <div class="ag-px-md">
                        <mat-checkbox
                          class="ag-px-md"
                          name="enableTypeAheadForPatronsGuests"
                          [(ngModel)]="advSearchOptions.enableTypeAheadForPatronsGuests"
                          >Patron
                        </mat-checkbox>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 text-end">
                    <button aria-label="Save" class="btn btn-primary" type="submit">Save</button>
                  </div>
                </div>
              </div>
            </form>
          }
        </div>
      }
      @if (newAS) {
        <div class="control-panel">
          <ng-container
            *ngTemplateOutlet="
              editSidenavHeader;
              context: {
                title: 'Advanced Search',
                action: goAdvanced.bind(this)
              }
            "
          ></ng-container>
          <h3 class="text-center">Advanced Search Qualifiers</h3>
          <div class="text-center ag-mb-sm" style="min-height: 20px">
            @if (advSearchSaving) {
              <mat-spinner diameter="16" style="margin: 0 auto"></mat-spinner>
            }
            @if (advSearchSaved) {
              <small>Saved</small>
            }
          </div>
          <div class="container-fluid">
            <div class="row">
              <div class="col-12 col-md-6">
                <h5 class="text-center">For Patron/Guest</h5>
                @if (advSearchQualiferOptPatronGuest) {
                  <div
                    class="drag-list drag-list-editable"
                    cdkDropList
                    (cdkDropListDropped)="
                      dropAdvSearchQualifer($event, advSearchQualiferOptPatronGuest)
                    "
                  >
                    @for (filter of advSearchQualiferOptPatronGuest; track filter; let i = $index) {
                      <div
                        cdkDrag
                        tabindex="0"
                        class="drag-list-item ag-pa-sm"
                        [cdkContextMenuTriggerFor]="asPatronMenu.template"
                        (cdkContextMenuOpened)="asPatronMenu.setIndex(i)"
                      >
                        <div *cdkDragPlaceholder class="drag-placeholder"></div>
                        @if (!isShareIt || (isShareIt && filter.filterId !== 9)) {
                          <div
                            fxLayout="row"
                            fxFlex
                            fxLayoutAlign="start center"
                            fxLayoutGap="10px"
                          >
                            <div>
                              <mat-icon>drag_handle</mat-icon>
                            </div>
                            <div>
                              <input
                                type="checkbox"
                                [attr.title]="filter.filterId"
                                [name]="filter.filterId"
                                [(ngModel)]="filter.display"
                                (change)="saveAdvSearchQualiferOpt()"
                              />
                            </div>
                            <div fxFlex>
                              <mat-form-field subscriptSizing="dynamic">
                                <input
                                  matInput
                                  [placeholder]="filter.description"
                                  [attr.title]="filter.description"
                                  [name]="filter.mappedDescription"
                                  [(ngModel)]="filter.mappedDescription"
                                  (blur)="saveAdvSearchQualiferOpt()"
                                />
                              </mat-form-field>
                            </div>
                          </div>
                        }
                      </div>
                    }
                    <ag-reorder-context-menu
                      #asPatronMenu
                      [total]="$safeNavigationMigration(advSearchQualiferOptPatronGuest?.length)"
                      [showRemove]="false"
                      (move)="
                        moveAdvSearchQualifer(
                          advSearchQualiferOptPatronGuest,
                          $event.from,
                          $event.to
                        )
                      "
                    ></ag-reorder-context-menu>
                  </div>
                }
              </div>
              <div class="col-12 col-md-6">
                <h5 class="text-center">For Staff</h5>
                @if (advSearchQualiferOptStaff) {
                  <div
                    class="drag-list drag-list-editable"
                    cdkDropList
                    (cdkDropListDropped)="dropAdvSearchQualifer($event, advSearchQualiferOptStaff)"
                  >
                    @for (filter of advSearchQualiferOptStaff; track filter; let i = $index) {
                      <div
                        cdkDrag
                        tabindex="0"
                        class="drag-list-item ag-pa-sm"
                        [cdkContextMenuTriggerFor]="asStaffMenu.template"
                        (cdkContextMenuOpened)="asStaffMenu.setIndex(i)"
                      >
                        <div *cdkDragPlaceholder class="drag-placeholder"></div>
                        @if (!isShareIt || (isShareIt && filter.filterId !== 9)) {
                          <div
                            fxLayout="row"
                            fxFlex
                            fxLayoutAlign="start center"
                            fxLayoutGap="10px"
                          >
                            <div>
                              <mat-icon>drag_handle</mat-icon>
                            </div>
                            <div>
                              <input
                                type="checkbox"
                                [attr.title]="filter.filterId"
                                [name]="filter.filterId"
                                [(ngModel)]="filter.display"
                                (change)="saveAdvSearchQualiferOpt()"
                              />
                            </div>
                            <div fxFlex>
                              <mat-form-field subscriptSizing="dynamic">
                                <input
                                  matInput
                                  [placeholder]="filter.description"
                                  [attr.title]="filter.description"
                                  [name]="filter.mappedDescription"
                                  [(ngModel)]="filter.mappedDescription"
                                  (blur)="saveAdvSearchQualiferOpt()"
                                />
                              </mat-form-field>
                            </div>
                          </div>
                        }
                      </div>
                    }
                    <ag-reorder-context-menu
                      #asStaffMenu
                      [total]="$safeNavigationMigration(advSearchQualiferOptStaff?.length)"
                      [showRemove]="false"
                      (move)="
                        moveAdvSearchQualifer(advSearchQualiferOptStaff, $event.from, $event.to)
                      "
                    ></ag-reorder-context-menu>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }
      <!-- Web Links -->
      @if (browse) {
        <div class="control-panel">
          <ng-container
            *ngTemplateOutlet="
              editSidenavHeader;
              context: {
                title: 'Search and Results',
                action: goSearchOptions.bind(this)
              }
            "
          ></ng-container>
          @if (webLinkOptions) {
            <form #f="ngForm" (ngSubmit)="saveWebLinksOptions(f)">
              <h3 class="text-center">Web Links</h3>
              <div class="padding-0-10">
                <div class="padding-5-15">Display Web Links Option On Separate Tab</div>
                <div class="width-300 inline-block text-start">
                  <mat-checkbox
                    class="ag-px-lg"
                    name="weblinkOnSeparateTabGuest"
                    [(ngModel)]="webLinkOptions.weblinkOnSeparateTab.guest"
                    >Guest</mat-checkbox
                  >
                </div>
                <div class="width-300 inline-block text-start">
                  <mat-checkbox
                    class="ag-px-lg"
                    name="weblinkOnSeparateTabPatron"
                    [(ngModel)]="webLinkOptions.weblinkOnSeparateTab.patron"
                    >Patron</mat-checkbox
                  >
                </div>
                <div class="width-300 inline-block text-start">
                  <mat-checkbox
                    class="ag-px-lg"
                    name="weblinkOnSeparateTabStaff"
                    [(ngModel)]="webLinkOptions.weblinkOnSeparateTab.staff"
                    >Staff
                  </mat-checkbox>
                </div>
              </div>
              <div class="padding-0-10">
                <div class="padding-5-15">Display Web Links on Choose Resources Screen</div>
                <div class="width-300 inline-block text-start">
                  <mat-checkbox
                    class="ag-px-lg"
                    name="weblinkOnChooseResourceScreenGuest"
                    [(ngModel)]="webLinkOptions.weblinkOnChooseResourceScreen.guest"
                    >Guest
                  </mat-checkbox>
                </div>
                <div class="width-300 inline-block text-start">
                  <mat-checkbox
                    class="ag-px-lg"
                    name="weblinkOnChooseResourceScreenPatron"
                    [(ngModel)]="webLinkOptions.weblinkOnChooseResourceScreen.patron"
                    >Patron
                  </mat-checkbox>
                </div>
                <div class="width-300 inline-block text-start">
                  <mat-checkbox
                    class="ag-px-lg"
                    name="weblinkOnChooseResourceScreenStaff"
                    [(ngModel)]="webLinkOptions.weblinkOnChooseResourceScreen.staff"
                    >Staff
                  </mat-checkbox>
                </div>
              </div>
              <div>
                <div>Web Link Tab Label</div>
                <mat-form-field appearance="outline" class="width-100">
                  <input
                    matInput
                    aria-label="Web Link Tab Label"
                    placeholder="Enter Tab Label"
                    maxlength="20"
                    [(ngModel)]="webLinkTabLabel"
                    [ngModelOptions]="{ standalone: true }"
                  />
                  <mat-hint align="end">{{ webLinkTabLabel.length }}/20</mat-hint>
                </mat-form-field>
                <br />
                <div>Web Link Page Text</div>
                <form #formText="ngForm" class="width-100">
                  <medium-editor-shared
                    #medEditorWebLink
                    [innerHTMLText]="webLinkPageText"
                    [location]="'editsidenav'"
                  >
                  </medium-editor-shared>
                </form>
              </div>
              <br />
              <button aria-label="Save" type="submit" class="btn btn-primary pull-right">
                Save
              </button>
            </form>
          }
        </div>
      }
      <!-- SEARCH > FACETS MANAGEMENT -->
      @if (facets) {
        <div class="control-panel width-320">
          <ng-container
            *ngTemplateOutlet="
              editSidenavHeader;
              context: {
                title: 'Search and Results',
                action: goSearchOptions.bind(this)
              }
            "
          ></ng-container>
          <h3 class="text-center">Facet Management</h3>
          <div class="text-center ag-mb-sm" style="min-height: 20px">
            @if (facetSaving) {
              <mat-spinner diameter="16" style="margin: 0 auto"></mat-spinner>
            }
            @if (facetSaved) {
              <small>Saved</small>
            }
          </div>
          <div class="container-fluid">
            <div class="row">
              <div class="col-12 col-md-6">
                <h5 class="text-center">For Patron/Guest</h5>
                @if (facetOptions) {
                  <div
                    class="drag-list drag-list-editable"
                    cdkDropList
                    (cdkDropListDropped)="dropFacets($event, facetsForPatronGuest)"
                  >
                    @for (facet of facetsForPatronGuest; track facet; let i = $index) {
                      <div
                        cdkDrag
                        tabindex="0"
                        class="drag-list-item ag-pa-sm"
                        [cdkContextMenuTriggerFor]="facetPatronMenu.template"
                        (cdkContextMenuOpened)="facetPatronMenu.setIndex(i)"
                      >
                        <div *cdkDragPlaceholder class="drag-placeholder"></div>
                        @if (!isShareIt || (isShareIt && facet.facetId !== 16)) {
                          <div
                            fxLayout="row"
                            fxFlex
                            fxLayoutAlign="start center"
                            fxLayoutGap="10px"
                          >
                            <div>
                              <mat-icon>drag_handle</mat-icon>
                            </div>
                            <div>
                              <input
                                type="checkbox"
                                [attr.title]="facet.facetId"
                                [name]="facet.filterId"
                                [(ngModel)]="facet.display"
                                (change)="saveFacetOptions()"
                              />
                            </div>
                            <div fxFlex>
                              <mat-form-field subscriptSizing="dynamic">
                                <input
                                  matInput
                                  [placeholder]="facet.description"
                                  [attr.title]="facet.description"
                                  [name]="facet.mappedDescription"
                                  [(ngModel)]="facet.mappedDescription"
                                  (blur)="saveFacetOptions()"
                                />
                              </mat-form-field>
                            </div>
                          </div>
                        }
                      </div>
                    }
                    <ag-reorder-context-menu
                      #facetPatronMenu
                      [total]="$safeNavigationMigration(facetsForPatronGuest?.length)"
                      [showRemove]="false"
                      (move)="moveFacet(facetsForPatronGuest, $event.from, $event.to)"
                    ></ag-reorder-context-menu>
                  </div>
                }
              </div>
              <div class="col-12 col-md-6">
                <h5 class="text-center">For Staff</h5>
                @if (facetOptions) {
                  <div
                    class="drag-list drag-list-editable"
                    cdkDropList
                    (cdkDropListDropped)="dropFacets($event, facetsForStaff)"
                  >
                    @for (facet of facetsForStaff; track facet; let i = $index) {
                      <div
                        cdkDrag
                        tabindex="0"
                        class="drag-list-item ag-pa-sm"
                        [cdkContextMenuTriggerFor]="facetStaffMenu.template"
                        (cdkContextMenuOpened)="facetStaffMenu.setIndex(i)"
                      >
                        <div *cdkDragPlaceholder class="drag-placeholder"></div>
                        @if (!isShareIt || (isShareIt && facet.facetId !== 16)) {
                          <div
                            fxLayout="row"
                            fxFlex
                            fxLayoutAlign="start center"
                            fxLayoutGap="10px"
                          >
                            <div>
                              <mat-icon>drag_handle</mat-icon>
                            </div>
                            <div>
                              <input
                                type="checkbox"
                                [attr.title]="facet.facetId"
                                [name]="facet.filterId"
                                [(ngModel)]="facet.display"
                                (change)="saveFacetOptions()"
                              />
                            </div>
                            <div fxFlex>
                              <mat-form-field subscriptSizing="dynamic">
                                <input
                                  matInput
                                  [placeholder]="facet.description"
                                  [attr.title]="facet.description"
                                  [name]="facet.mappedDescription"
                                  [(ngModel)]="facet.mappedDescription"
                                  (blur)="saveFacetOptions()"
                                />
                              </mat-form-field>
                            </div>
                          </div>
                        }
                      </div>
                    }
                    <ag-reorder-context-menu
                      #facetStaffMenu
                      [total]="$safeNavigationMigration(facetsForStaff?.length)"
                      [showRemove]="false"
                      (move)="moveFacet(facetsForStaff, $event.from, $event.to)"
                    ></ag-reorder-context-menu>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }
      <!--  FULL RECORD -->
      @if (detail) {
        <div class="control-panel width-400">
          <ng-container
            *ngTemplateOutlet="
              editSidenavHeader;
              context: {
                title: 'Search and Results',
                action: goSearchOptions.bind(this)
              }
            "
          ></ng-container>
          <ag-side-nav-full-record
            [fullRecordOptions]="fullRecordOptions"
            [canShowILLLenderColumn]="userData.isCustSuperUser && isShareIt"
            (updateFullRecord)="updateFullRecordOptions($event)"
          >
          </ag-side-nav-full-record>
          <br />
          <br />
        </div>
      }
      <!--
                                  ==================================
                                  ============= PAGES ==============
                                  ==================================
                                  -->
      @if (pages) {
        <div class="control-panel width-400">
          <ng-container
            *ngTemplateOutlet="
              editSidenavHeader;
              context: {
                title: 'UX Admin > Settings',
                action: goStart.bind(this)
              }
            "
          ></ng-container>
          <!-- Create a New Page -->
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" class="ag-mb-sm">
            <button mat-stroked-button type="button" (click)="createPage()">
              <mat-icon>web</mat-icon>
              New Page
            </button>
            <button mat-stroked-button type="button" (click)="createPageLink()">
              <mat-icon>link</mat-icon>
              New Page Link
            </button>
            <button mat-stroked-button type="button" (click)="createWidget()">
              <mat-icon>extension</mat-icon>
              New Widget
            </button>
          </div>
          <!-- Active and Non-Active Pages -->
          <h3 class="text-center">Active Pages</h3>
          <div class="text-center ag-mb-sm" style="min-height: 20px">
            @if (pagesSaving) {
              <mat-spinner diameter="16" style="margin: 0 auto"></mat-spinner>
            }
            @if (pagesSaved) {
              <small>Saved</small>
            }
          </div>
          <div
            class="drag-list drag-list-editable"
            cdkDropList
            (cdkDropListDropped)="dropActivePages($event, activePages)"
          >
            @for (list of activePages; track list; let i = $index) {
              <div
                cdkDrag
                tabindex="0"
                class="drag-list-item ag-pa-sm"
                [cdkContextMenuTriggerFor]="pagesMenu.template"
                (cdkContextMenuOpened)="pagesMenu.setIndex(i)"
              >
                <div *cdkDragPlaceholder class="drag-placeholder"></div>
                <div fxLayout="row" fxFlex fxLayoutAlign="start center" fxLayoutGap="10px">
                  <div>
                    <mat-icon>drag_handle</mat-icon>
                  </div>
                  <div>
                    @if (i === 0 && !list.linkPage) {
                      <mat-icon>home</mat-icon>
                    }
                    @if (i !== 0 && list.linkPage) {
                      <mat-icon>link</mat-icon>
                    }
                    @if (i !== 0 && !list.linkPage) {
                      <mat-icon>web</mat-icon>
                    }
                  </div>
                  <div fxFlex fxLayout="column" class="flex-ellipsis">
                    <div class="ellipsis flex-ellipsis">{{ list?.label }}</div>
                    @if (list?.targetLibForPublishedPage) {
                      <span
                        class="ellipsis flex-ellipsis mat-caption"
                        title="From: {{ list?.targetLibForPublishedPage }}"
                        >From: {{ list?.targetLibForPublishedPage }}</span
                      >
                    }
                  </div>
                  <button mat-icon-button type="button" (click)="editCustomPage(list, 'page')">
                    <mat-icon>edit</mat-icon>
                  </button>
                  @if (
                    (userData.isCustSuperUser && list?.isGlobal) ||
                    (userData.isLibSuperUser && !list?.isGlobal)
                  ) {
                    <button mat-icon-button type="button" (click)="deletePage(list, i)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  }
                </div>
              </div>
            }
            <ag-reorder-context-menu
              #pagesMenu
              [total]="$safeNavigationMigration(activePages?.length)"
              (move)="moveActivePage($event.from, $event.to)"
              (remove)="deletePage(activePages[$event], $event)"
            ></ag-reorder-context-menu>
          </div>
          @if (inactivePages?.length > 0 && !isOnlyCustomerCareInactivePage && !areAllWidgetPages) {
            <div>
              <h3 class="text-center ag-mt-sm">Non-Active Pages</h3>
              <div class="drag-list">
                @for (list of inactivePages; track list; let i = $index) {
                  @if (list?.guid !== 'thisIsACustomerCarePage' && !list?.widgetPage) {
                    <div class="drag-list-item ag-pa-sm">
                      <div fxLayout="row" fxFlex fxLayoutAlign="start center" fxLayoutGap="10px">
                        <div>
                          @if (list.linkPage) {
                            <mat-icon>link</mat-icon>
                          }
                          @if (!list.linkPage) {
                            <mat-icon>web</mat-icon>
                          }
                        </div>
                        <div fxFlex fxLayout="column" class="flex-ellipsis">
                          <div class="ellipsis flex-ellipsis">{{ list?.label }}</div>
                          @if (list?.targetLibForPublishedPage) {
                            <span
                              class="ellipsis flex-ellipsis mat-caption"
                              title="From: {{ list?.targetLibForPublishedPage }}"
                              >From: {{ list?.targetLibForPublishedPage }}</span
                            >
                          }
                        </div>
                        <button
                          mat-icon-button
                          type="button"
                          (click)="editCustomPage(list, 'page')"
                        >
                          <mat-icon>edit</mat-icon>
                        </button>
                        @if (
                          (userData.isCustSuperUser && list?.isGlobal) ||
                          (userData.isLibSuperUser && !list?.isGlobal)
                        ) {
                          <button mat-icon-button type="button" (click)="deletePage(list, i)">
                            <mat-icon>delete</mat-icon>
                          </button>
                        }
                      </div>
                    </div>
                  }
                }
              </div>
            </div>
          }
          @if (userData.isStaff && userData.isCustSuperUser) {
            <h3 class="text-center">System Pages</h3>
            <div class="drag-list">
              <div class="drag-list-item ag-pa-sm">
                <div fxLayout="row" fxFlex fxLayoutAlign="start center" fxLayoutGap="10px">
                  <div>
                    <mat-icon>web</mat-icon>
                  </div>
                  <div fxFlex class="ellipsis flex-ellipsis">
                    Customer Care
                    @if (!isActiveCustomerCarePage) {
                      <span><strong>(Inactive)</strong></span>
                    }
                  </div>
                  <button mat-icon-button type="button" (click)="editCustomerCarePage()">
                    <mat-icon>edit</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          }
          @if (doWidgetPagesExist) {
            <h3 class="text-center">Widgets</h3>
            <div class="drag-list">
              @for (page of inactivePages; track page; let i = $index) {
                @if (page?.widgetPage) {
                  <div class="drag-list-item ag-pa-sm">
                    <div fxLayout="row" fxFlex fxLayoutAlign="start center" fxLayoutGap="10px">
                      <div>
                        <mat-icon>extension</mat-icon>
                      </div>
                      <div fxFlex class="truncate-ellipsis">{{ page?.label }}</div>
                      <button
                        mat-icon-button
                        type="button"
                        (click)="editCustomPage(page, 'widget')"
                      >
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button mat-icon-button type="button" (click)="deletePage(page, i)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                }
              }
            </div>
          }
        </div>
      }
      @if (pagesCreate) {
        <div class="control-panel">
          <ng-container
            *ngTemplateOutlet="
              editSidenavHeader;
              context: {
                title: 'Pages and Widgets',
                action: goPages.bind(this)
              }
            "
          ></ng-container>
          <edit-page [pageType]="pageType" (resetNav)="goStart()"></edit-page>
        </div>
      }
      <!--
                                =====
                                ============= DESIGN ==============
                                =====
                                -->
      @if (design) {
        <div class="control-panel" style="min-width: 480px; max-width: 480px">
          <ng-container
            *ngTemplateOutlet="
              editSidenavHeader;
              context: {
                title: 'UX Admin > Settings',
                action: goStart.bind(this)
              }
            "
          ></ng-container>
          <h3 class="text-center">Design</h3>
          <div class="padding-10-25 pointer" tabindex="0" (agInteract)="goStyle()">
            Theme
            <i class="fa fa-angle-right pull-right" aria-hidden="true"></i>
          </div>
          <div class="padding-10-25 pointer" tabindex="0" (agInteract)="goHeader()">
            Header
            <i class="fa fa-angle-right pull-right" aria-hidden="true"></i>
          </div>
          @if (showFooterOptions) {
            <div class="padding-10-25 pointer" tabindex="0" (agInteract)="goFooter()">
              Footer
              <i class="fa fa-angle-right pull-right" aria-hidden="true"></i>
            </div>
          }
        </div>
      }
      <!--
                              =====
                              ====================== HEADER ===========================
                              =====
                              -->
      @if (header) {
        <div class="control-panel width-400">
          <ng-container
            *ngTemplateOutlet="
              editSidenavHeader;
              context: {
                title: 'Design',
                action: goDesignOptions.bind(this)
              }
            "
          ></ng-container>
          <h3 class="text-center">Header</h3>
          <div class="container-fluid">
            <div class="row mb-3">
              <div class="form-group col-12 col-md-6">
                <h6 class="width-100">Branding</h6>
                <mat-form-field appearance="outline" class="width-100">
                  <mat-select title="Branding Logo Options" id="logotype" [(ngModel)]="branding">
                    <mat-option value="libOnly">Use Library Name</mat-option>
                    <mat-option value="imageOnly">Use Image</mat-option>
                    <mat-option value="customText">Use Custom Text</mat-option>
                    <mat-option value="bothImageText">Use Image and Text</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12">
                @if (branding === 'libOnly') {
                  <div>
                    <div>{{ userData.libraryName }}</div>
                  </div>
                }
                @if (branding === 'imageOnly') {
                  <div class="row">
                    <div class="col-12 col-md-6">
                      <div class="form-group">
                        <label for="photo">Image Upload</label>
                        <input
                          type="file"
                          class="form-control"
                          name="photo"
                          id="photo"
                          (change)="onFileSelected($event)"
                          accept="image/*"
                        />
                        @if (selectedFile) {
                          <button
                            aria-label="Upload"
                            type="button"
                            class="btn btn-primary ag-my-sm"
                            (click)="uploadImage()"
                            [disabled]="isUploading"
                          >
                            @if (isUploading) {
                              Uploading...
                            } @else {
                              Upload Image
                            }
                          </button>
                        }
                      </div>
                    </div>
                    <div class="col-12 col-md-6 text-center">
                      @if (!logoImageURL) {
                        <div class="width-100 border-25 back-offset-three"></div>
                      }
                      @if (logoImageURL) {
                        <div class="width-100">
                          <img [src]="logoImageURL" alt="Logo Image" class="width-100" />
                        </div>
                      }
                    </div>
                  </div>
                }
                @if (branding === 'customText') {
                  <div>
                    <div class="form-group">
                      <mat-form-field appearance="outline" class="width-100">
                        <input
                          matInput
                          aria-label="Custom Logo Text"
                          placeholder="Custom Text"
                          maxlength="100"
                          [(ngModel)]="logoCustomText"
                          [ngModelOptions]="{ standalone: true }"
                        />
                        <mat-hint align="end">{{ logoCustomText.length }}/100</mat-hint>
                      </mat-form-field>
                    </div>
                  </div>
                }
                @if (branding === 'bothImageText') {
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="width-100">
                          <input
                            matInput
                            aria-label="Custom Text"
                            placeholder="Custom Text"
                            maxlength="100"
                            [(ngModel)]="logoCustomText"
                            [ngModelOptions]="{ standalone: true }"
                          />
                          <mat-hint align="end">{{ logoCustomText.length }}/100</mat-hint>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="form-group">
                        <label for="photo">Image Upload</label>
                        <input
                          type="file"
                          class="form-control"
                          name="photo"
                          id="photo"
                          (change)="onFileSelected($event)"
                          accept="image/*"
                        />
                        <button
                          aria-label="Save"
                          type="button"
                          class="btn btn-primary ag-my-sm"
                          [disabled]="!logoCustomText || !selectedFile || isUploading"
                          (click)="uploadImage()"
                        >
                          @if (isUploading) {
                            Uploading...
                          } @else {
                            Upload Image
                          }
                        </button>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 text-center">
                      @if (!logoImageURL) {
                        <div class="width-100 border-25 back-offset-three"></div>
                      }
                      @if (logoImageURL) {
                        <div style="width: 100%">
                          <img [src]="logoImageURL" alt="Custom Logo" style="max-width: 95%" />
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-12 col-md-6">
                <h6>Branding Tooltip</h6>
                <mat-form-field appearance="outline" class="width-100">
                  <input
                    matInput
                    id="titletext"
                    placeholder="Enter Tooltip"
                    title="Tooltip Text"
                    [(ngModel)]="logoRedirectTITLE"
                  />
                  <mat-hint>Tooltip to display when hovering</mat-hint>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-6">
                <h6>Branding URL</h6>
                <mat-form-field appearance="outline" class="width-100">
                  <input
                    matInput
                    id="targeturl"
                    title="Branding URL"
                    placeholder="Enter URL"
                    [(ngModel)]="logoRedirectURL"
                  />
                  <mat-hint>The URL to navigate to when clicked</mat-hint>
                </mat-form-field>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-12 col-md-6">
                <span>
                  <mat-checkbox [(ngModel)]="showLanguages" (change)="language($event)">
                    <h6 class="width-100">Display Select Language</h6>
                  </mat-checkbox>
                </span>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-12 col-md-6">
                <h6>Login Button Text</h6>
                <mat-form-field appearance="outline" class="width-100">
                  <input
                    matInput
                    id="logintext"
                    placeholder="Enter Login Text"
                    title="Login button text"
                    maxlength="10"
                    [(ngModel)]="loginButtonText"
                  />
                  <mat-hint align="start">Text displayed for the Login Button</mat-hint>
                  <mat-hint align="end">{{ loginButtonText?.length || 0 }}/10</mat-hint>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-6"></div>
            </div>
            <div class="row mb-3">
              <div class="col-12 text-end ag-my-md">
                <button
                  type="button"
                  aria-label="Save"
                  class="btn btn-primary"
                  [disabled]="
                    !(
                      (branding === 'libOnly' ||
                        branding === 'imageOnly' ||
                        ((branding === 'customText' || branding === 'bothImageText') &&
                          logoCustomText.length > 0)) &&
                      loginButtonText.length > 0
                    )
                  "
                  (click)="saveHeader()"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      }
      <!--
                                          =====
                                          ====================== Theme ========================
                                          =====
                                          -->
      @if (style) {
        <div class="control-panel" style="min-width: 320px; width: 320px">
          <ng-container
            *ngTemplateOutlet="
              editSidenavHeader;
              context: {
                title: 'Design',
                action: goDesignOptions.bind(this)
              }
            "
          ></ng-container>
          <color
            [color]="colorPalette"
            [themes]="themesArray"
            [showSaveApply]="showSaveApply"
            (themesEE)="updateThemesArray($event)"
            (colorsEE)="updateColorsArray($event)"
          ></color>
        </div>
      }
      <!--
                                        ============
                                        ============= STAFF OPTIONS ==============
                                        ============
                                        -->
      @if (staff) {
        <div class="control-panel">
          <ng-container
            *ngTemplateOutlet="
              editSidenavHeader;
              context: {
                title: 'UX Admin > Settings',
                action: goStart.bind(this)
              }
            "
          ></ng-container>
          <h3 class="text-center">Staff Options</h3>
          <div class="text-center ag-mb-sm" style="min-height: 20px">
            @if (staffSaving) {
              <mat-spinner diameter="16" style="margin: 0 auto"></mat-spinner>
            }
            @if (staffSaved) {
              <small>Saved</small>
            }
          </div>
          <div class="container-fluid">
            <div class="row">
              <div class="col-12 col-md-6">
                <div fxLayout="row" fxLayoutAlign="space-between center" class="ag-mb-sm">
                  <h6 class="color-primary" style="margin: 0">Local Tab Order</h6>
                  @if (staffTabOptions?.showGlobal) {
                    <button
                      mat-icon-button
                      type="button"
                      matTooltip="Copy local order to global"
                      (click)="applyLocalToGlobal()"
                    >
                      <mat-icon>arrow_forward</mat-icon>
                    </button>
                  }
                </div>
                <div
                  cdkDropList
                  cdkDropListLockAxis="y"
                  class="drag-list drag-list-editable"
                  (cdkDropListDropped)="dropStaffLocalTabs($event)"
                >
                  @for (staff of stafftabsLocal; track staff; let i = $index) {
                    <div
                      cdkDrag
                      tabindex="0"
                      [cdkContextMenuTriggerFor]="localTabMenu.template"
                      (cdkContextMenuOpened)="localTabMenu.setIndex(i)"
                      class="drag-list-item ag-pa-sm"
                    >
                      <div *cdkDragPlaceholder class="drag-placeholder ag-pa-sm"></div>
                      <div fxLayout="row" fxFlex fxLayoutAlign="start center" fxLayoutGap="10px">
                        <mat-icon>drag_handle</mat-icon>
                        <div class="set-label-staff-link" fxFlex="grow">
                          <div class="set-label truncate-ellipsis">{{ staff.menuText }}</div>
                        </div>
                      </div>
                    </div>
                  }
                  <ag-reorder-context-menu
                    #localTabMenu
                    [total]="$safeNavigationMigration(stafftabsLocal?.length)"
                    [showRemove]="false"
                    (move)="moveStaffLocalTab($event.from, $event.to)"
                  ></ag-reorder-context-menu>
                </div>
              </div>
              @if (staffTabOptions?.showGlobal) {
                <div class="col-12 col-md-6">
                  <div fxLayout="row" fxLayoutAlign="space-between center" class="ag-mb-sm">
                    <h6 class="color-header-color" style="margin: 0">Global Tab Order</h6>
                    <button
                      mat-icon-button
                      type="button"
                      matTooltip="Copy global order to local"
                      (click)="applyGlobalToLocal()"
                    >
                      <mat-icon>arrow_back</mat-icon>
                    </button>
                  </div>
                  @if (staffTabOptions.showGlobal) {
                    <div
                      cdkDropList
                      cdkDropListLockAxis="y"
                      class="drag-list drag-list-editable"
                      (cdkDropListDropped)="dropStaffGlobalTabs($event)"
                    >
                      @for (staff of stafftabsGlobal; track staff; let i = $index) {
                        <div
                          cdkDrag
                          tabindex="0"
                          [cdkContextMenuTriggerFor]="globalTabMenu.template"
                          (cdkContextMenuOpened)="globalTabMenu.setIndex(i)"
                          class="drag-list-item ag-pa-sm"
                        >
                          <div *cdkDragPlaceholder class="drag-placeholder ag-pa-sm"></div>
                          <div
                            fxLayout="row"
                            fxFlex
                            fxLayoutAlign="start center"
                            fxLayoutGap="10px"
                          >
                            <mat-icon>drag_handle</mat-icon>
                            <div class="set-label-staff-link" fxFlex="grow">
                              <div class="set-label truncate-ellipsis">{{ staff.menuText }}</div>
                            </div>
                          </div>
                        </div>
                      }
                      <ag-reorder-context-menu
                        #globalTabMenu
                        [total]="$safeNavigationMigration(stafftabsGlobal?.length)"
                        [showRemove]="false"
                        (move)="moveStaffGlobalTab($event.from, $event.to)"
                      ></ag-reorder-context-menu>
                    </div>
                  }
                </div>
              }
              @if (!staffTabOptions.showGlobal && !globalStaffTabReadOnlyFlag) {
                <div class="col-12 col-md-6">
                  <h6 class="color-header-color width-100">Global Tab Order (Read Only)</h6>
                  <div class="drag-list">
                    @for (staff of stafftabsGlobal; track staff) {
                      <div class="drag-list-item ag-pa-sm">
                        <div class="set-label-staff-link truncate-ellipsis">
                          {{ staff.menuText }}
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      }
      <ng-template #editSidenavHeader let-title="title" let-action="action">
        <div class="text-start semi-bold pointer ag-mb-sm" tabindex="0" (agInteract)="action()">
          <i class="fa fa-chevron-circle-left pull-left" aria-hidden="true"></i>
          {{ title }}
          <i
            class="fa fa-times pull-right close-sidenav"
            aria-hidden="true"
            title="Close Side Navigation"
            tabindex="0"
            (agInteract)="closeOverlay()"
          ></i>
        </div>
      </ng-template>
    }
  </div>
}
